import FinanceSerializer from './base';
import { isEmpty } from '@ember/utils';

export default class TillSession extends FinanceSerializer {
  normalize(modelClass, payload) {
    let defaults = {
      isOpen: false,
      hundredsCount: 0,
      fiftiesCount: 0,
      twentiesCount: 0,
      tensCount: 0,
      fivesCount: 0,
      coinsCount: 0,
      coinsAmount: 0,
    };
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);
    payload.balance = ((payload.balance ?? 0) / 100).toFixed(2);
    payload.coinsAmount = (payload.coinsAmount / 100).toFixed(2);
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    if (!isEmpty(hash.depositSlipId)) {
      hash.depositSlipId = parseInt(hash.depositSlipId, 10);
    }
    if (!isEmpty(hash.tillId)) {
      hash.tillId = parseInt(hash.tillId, 10);
    }
    if (!isEmpty(hash.coinsAmount)) {
      hash.coinsAmount = Math.round(hash.coinsAmount * 100);
    }
    // Balance is calculated on the backend - don't send it.
    delete hash.balance;
    return hash;
  }
}
